import Header from "./Components/Header";
import "../styles/CookClubTerms.css";
import Footer from "./Components/Footer";
import SEO from "./Components/SEO";

function PrivacyPolicy() {
    return (
        <div className="privacy-policy-page">
            <Header />

            <SEO
                title="Privacy Policy | DENNY"
                description="Learn how Denny collects, uses, stores and protects your personal information in accordance with POPIA and applicable South African privacy laws."
                keywords="Denny privacy policy, POPIA, personal information, data protection, privacy, Denny South Africa"
            />
            <div className="cook-club-terms-container">
                <h1>Privacy Policy</h1>

                <p><strong>Version:</strong> 1.0</p>
                <p><strong>Last Updated:</strong> 21 July 2026</p>

                <h2>1. Introduction</h2>

                <p>
                    Welcome to the Denny website ("Website").
                </p>

                <p>
                    Denny is a proudly South African food brand within the Libstar
                    Group. We are committed to protecting your privacy and ensuring
                    that your personal information is collected, processed, stored
                    and protected responsibly and in accordance with the Protection
                    of Personal Information Act, 2013 ("POPIA"), and other
                    applicable South African legislation.
                </p>

                <p>
                    This Privacy Policy explains how we collect, use, disclose and
                    protect your personal information when you use our Website,
                    participate in the Denny Cook Club, subscribe to our
                    communications, enter competitions or otherwise interact with
                    Denny online.
                </p>

                <p>
                    By using this Website, you acknowledge that you have read and
                    understood this Privacy Policy.
                </p>

                <h2>2. Definitions</h2>

                <p>
                    For the purposes of this Privacy Policy:
                </p>

                <p>
                    <strong>"Denny", "we", "our", or "us"</strong> refers to the
                    Denny brand within the Libstar Group.
                </p>

                <p>
                    <strong>"You" or "your"</strong> refers to any visitor or user
                    of the Website.
                </p>

                <p>
                    <strong>"Personal Information"</strong> has the meaning assigned
                    to it in POPIA and includes any information relating to an
                    identifiable natural or juristic person.
                </p>

                <h2>3. Information We Collect</h2>

                <p>
                    Depending on how you use our Website, we may collect:
                </p>

                <h3>Personal Information</h3>

                <ul>
                    <li>Full name</li>
                    <li>Email address</li>
                    <li>Telephone number</li>
                    <li>Province or country</li>
                    <li>Username and password (where applicable)</li>
                    <li>Date of birth (where required for competitions)</li>
                    <li>Marketing preferences</li>
                </ul>

                <h3>Cook Club Information</h3>

                <p>
                    Where you join the Denny Cook Club or submit recipes, we may
                    collect:
                </p>

                <ul>
                    <li>Recipe submissions</li>
                    <li>Photographs</li>
                    <li>Videos</li>
                    <li>User biographies</li>
                    <li>Social media handles</li>
                    <li>Competition entries</li>
                    <li>User-generated content</li>
                </ul>

                <h3>Technical Information</h3>

                <p>
                    When visiting our Website we may automatically collect:
                </p>

                <ul>
                    <li>IP address</li>
                    <li>Browser type</li>
                    <li>Device type</li>
                    <li>Operating system</li>
                    <li>Website usage information</li>
                    <li>Cookie information</li>
                    <li>Pages visited</li>
                    <li>Time spent on the Website</li>
                </ul>

                <h2>4. How We Collect Information</h2>

                <p>We collect information:</p>

                <ul>
                    <li>When you complete online forms.</li>
                    <li>When you subscribe to newsletters.</li>
                    <li>When you enter competitions.</li>
                    <li>When you upload recipes or videos.</li>
                    <li>When you contact us.</li>
                    <li>Through cookies and analytics technologies.</li>
                    <li>Through social media integrations.</li>
                    <li>Through lawful third-party sources where appropriate.</li>
                </ul>

                <h2>5. Why We Collect Personal Information</h2>

                <p>We collect your information to:</p>

                <ul>
                    <li>Operate and improve our Website.</li>
                    <li>Manage the Denny Cook Club.</li>
                    <li>Respond to enquiries.</li>
                    <li>Process competition entries.</li>
                    <li>Send newsletters where you have consented.</li>
                    <li>Improve recipes, content and user experience.</li>
                    <li>Monitor Website performance.</li>
                    <li>Analyse Website traffic.</li>
                    <li>Comply with legal obligations.</li>
                    <li>Detect fraud or misuse.</li>
                    <li>Protect the security of our systems.</li>
                </ul>

                <p>
                    We only process personal information where we have a lawful
                    basis to do so.
                </p>

                <h2>6. Marketing Communications</h2>

                <p>
                    Where you have provided your consent, we may send you:
                </p>

                <ul>
                    <li>Recipes</li>
                    <li>Product updates</li>
                    <li>Promotions</li>
                    <li>Competitions</li>
                    <li>Newsletters</li>
                    <li>Seasonal campaigns</li>
                    <li>Surveys</li>
                    <li>Events</li>
                </ul>

                <p>
                    You may unsubscribe at any time by using the unsubscribe link
                    contained in our emails or by contacting us directly.
                </p>

                <h2>7. Cookies</h2>

                <p>
                    Our Website uses cookies and similar technologies to:
                </p>

                <ul>
                    <li>Remember your preferences.</li>
                    <li>Improve Website functionality.</li>
                    <li>Measure Website performance.</li>
                    <li>Analyse visitor behaviour.</li>
                    <li>Support advertising and marketing activities.</li>
                </ul>

                <p>
                    Further information is available in our Cookies Policy.
                </p>

                <h2>8. Sharing Your Information</h2>

                <p>
                    We do not sell your personal information.
                </p>

                <p>
                    Your information may be shared with trusted third parties where
                    necessary, including:
                </p>

                <ul>
                    <li>Website hosting providers</li>
                    <li>Analytics providers</li>
                    <li>Email marketing platforms</li>
                    <li>Competition administrators</li>
                    <li>Technology providers</li>
                    <li>Professional advisers</li>
                    <li>Regulatory authorities where legally required</li>
                </ul>

                <p>
                    All service providers are expected to maintain appropriate
                    confidentiality and security measures.
                </p>

                <h2>9. International Transfers</h2>

                <p>
                    Some service providers may process information outside South
                    Africa.
                </p>

                <p>
                    Where personal information is transferred internationally, we
                    will take reasonable steps to ensure that an adequate level of
                    protection is maintained in accordance with applicable law.
                </p>

                <h2>10. Data Security</h2>

                <p>
                    We implement reasonable technical and organisational safeguards
                    to protect personal information against:
                </p>

                <ul>
                    <li>Loss</li>
                    <li>Unauthorised access</li>
                    <li>Disclosure</li>
                    <li>Alteration</li>
                    <li>Destruction</li>
                    <li>Misuse</li>
                </ul>

                <p>
                    While we take reasonable precautions, no internet transmission
                    or electronic storage system can be guaranteed to be completely
                    secure.
                </p>

                <h2>11. Data Retention</h2>

                <p>
                    We retain personal information only for as long as:
                </p>

                <ul>
                    <li>It is required for the purpose for which it was collected.</li>
                    <li>Required by law.</li>
                    <li>Necessary to resolve disputes.</li>
                    <li>Necessary to protect our legal rights.</li>
                </ul>

                <p>
                    When no longer required, information will be securely deleted
                    or anonymised where appropriate.
                </p>

                <h2>12. Your Rights</h2>

                <p>
                    Subject to applicable legislation, you may request to:
                </p>

                <ul>
                    <li>Access your personal information.</li>
                    <li>Correct inaccurate information.</li>
                    <li>Update your information.</li>
                    <li>Withdraw consent where processing is based on consent.</li>
                    <li>Request deletion of information where legally permissible.</li>
                    <li>Object to certain forms of processing.</li>
                    <li>Lodge a complaint with the Information Regulator.</li>
                </ul>

                <p>
                    Requests may be subject to verification of identity.
                </p>

                <h2>13. Children's Privacy</h2>

                <p>
                    Certain competitions or promotions may involve minors.
                </p>

                <p>
                    Where personal information relating to children is collected,
                    this will only occur with the consent of a parent or legal
                    guardian where required by law.
                </p>

                <h2>14. Third-Party Websites</h2>

                <p>
                    Our Website may contain links to third-party websites.
                </p>

                <p>
                    We are not responsible for the privacy practices or content of
                    external websites. Users should review the privacy policies of
                    those websites separately.
                </p>

                <h2>15. User-Generated Content</h2>

                <p>
                    Where users submit recipes, photographs, videos, comments or
                    other content to the Denny Cook Club or related features, such
                    submissions may become publicly visible.
                </p>

                <p>
                    Please avoid including confidential or sensitive personal
                    information in publicly accessible content.
                </p>

                <h2>16. Changes to this Privacy Policy</h2>

                <p>
                    We may update this Privacy Policy from time to time to reflect:
                </p>

                <ul>
                    <li>Changes in legislation.</li>
                    <li>Changes to our services.</li>
                    <li>Improvements to our Website.</li>
                    <li>New technologies.</li>
                    <li>Operational requirements.</li>
                </ul>

                <p>
                    The latest version will always be available on this Website.
                </p>

                <h2>17. Contact Us</h2>

                <p>
                    If you have any questions regarding this Privacy Policy or the
                    processing of your personal information, please contact:
                </p>

                <p>
                    <strong>Denny</strong><br />
                    A brand within the Libstar Group<br />
                    Address:<br />
                    12 Barlinka Avenue<br />
                    Montagu<br />
                    6720<br />
                    South Africa
                </p>

                <p>
                    Telephone: +27 23 614 2359<br />
                    Email: [Insert Privacy or Information Officer Email Address]
                </p>

                <h2>18. Complaints</h2>

                <p>
                    If you believe your personal information has not been handled
                    in accordance with applicable legislation, you may contact
                    Denny using the details above.
                </p>

                <p>
                    You also have the right to lodge a complaint with the South
                    African Information Regulator in accordance with POPIA.
                </p>
            </div>

            <Footer />
        </div>
    );
}

export default PrivacyPolicy;
